import SectionHeading from "./SectionHeading";

interface Story {
  title: string;
  category: string;
  image: string;
}

// Unsplash placeholders — swap for your own imagery later.
const STORIES: Story[] = [
  { category: "History", title: "Amber Fort", image: "https://images.unsplash.com/photo-1587295656906-b6e9a1c7f6d4?auto=format&fit=crop&w=600&q=70" },
  { category: "Culture", title: "Pushkar Fair: A Timeless Tradition", image: "https://images.unsplash.com/photo-1572445271230-a78b5944a659?auto=format&fit=crop&w=600&q=70" },
  { category: "Hidden Gem", title: "The Abandoned Bhangarh Mystery", image: "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?auto=format&fit=crop&w=600&q=70" },
  { category: "Spiritual", title: "Varanasi Ghats", image: "https://images.unsplash.com/photo-1561361513-2d000a50f0dc?auto=format&fit=crop&w=600&q=70" },
];

export default function Stories() {
  return (
    <section id="stories" className="bg-cream py-20">
      <div className="container-page">
        <SectionHeading title="Stories of India" action="Read More Stories →" />
        <div className="mt-10 grid grid-cols-2 gap-4 lg:grid-cols-4">
          {STORIES.map((s) => (
            <article
              key={s.title}
              className="group relative h-52 overflow-hidden rounded-2xl shadow-card"
            >
              <img
                src={s.image}
                alt={s.title}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-900/90 via-navy-900/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-4">
                <span className="rounded-full bg-gold-500 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-navy-900">
                  {s.category}
                </span>
                <h3 className="mt-2 font-display text-sm font-semibold text-white">
                  {s.title}
                </h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
